export class TimeService {
	private currentDate: string;

	constructor() {
		this.currentDate = $('meta[name="isodatetime"]').attr('content');
	}

	public set CurrentDate(date: string) {
		this.currentDate = date;
	}

	public get CurrentDate(): string {
		return this.currentDate;
	}

	public formatDate(date: string): string {
		if (date) {
			try {
				return new Date(date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1')).toISOString();
			} catch (e) {
				console.log(e);
			}
		}
		return '';
	}

	public getCurrentAge(date: moment.Moment): number {
		return moment(this.currentDate).diff(date, 'years');
	}

	public getCurrentAgeInMonths(date: moment.Moment): number {
		return moment(this.currentDate).diff(date, 'months');
	}

	public getDefaultBirthday(age: number): string {
		return moment().subtract(age, 'years').format();
	}

	public isOlderThan(dob: string, age: number): boolean {
		return moment(dob).isBefore(moment().subtract(age, 'years'));
	}

	public isYounger(dob: string, age: number): boolean {
		return moment(dob).isAfter(moment().subtract(age, 'years'));
	}

	public isBetweenAges(dob: string, minAge: number, maxAge: number): boolean {
		const age = moment().diff(moment(dob), 'years');
		return age >= minAge && age <= maxAge;
	}

	public hasReachedAgeSince(dob: string, date: string, age: number): boolean {
		const ageBeforeUpdate = moment(date).diff(moment(dob), 'years');
		const ageAtCurrentDate = this.getCurrentAge(moment(dob));
		return ageBeforeUpdate < age && ageAtCurrentDate >= age;
	}
}
